var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:['sticky-menu', { 'is-sticked': _vm.visible }]},[_vm._t("default")],2),_vm._v(" "),_c('div',{ref:"stickabler"})])
}
var staticRenderFns = []

export { render, staticRenderFns }